<template>
  <div>
    <VueTimepicker
      v-model="date"
      style="border-radius: 5px"
      input-class="form-control timepicker"
      input-width="100%"
      :hour-range="hourRange"
      :minute-range="minRange"
      scrollable
      v-bind="$props"
      @input="onInput"
    >
    </VueTimepicker>
  </div>
</template>

<script>
import VueTimepicker from 'vue2-timepicker/src/vue-timepicker.vue'

export default {
  components: {
    VueTimepicker
  },
  props: {
    value: {
      //
    },
    min: {
      //
    },
    max: {
      //
    },
    allowedDates: {
      //
    },
    'minute-interval': {},
    disabled: {},
    placeholder: {},
    format: {},
    'hide-clear-button': {
      default: false
    },
    hourRange: { default: null },
    minRange: { default: null }
  },
  data() {
    return {
      date: this.value,
      menu: false
    }
  },
  mounted() {
    // console.log(this.$props)
  },

  methods: {
    onInput(date) {
      this.menu = false
      this.$emit('input', date)
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/elements/TimePicker.vue